import { API_BASE_URL } from '../config';
import api from './axiosInstance';

export async function getAllInternalStates() {
  try {
    const response = await api.get(
      `${API_BASE_URL}/InternalStatusCatalog/GetAll`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    error.customMessage =
      'No se pudo obtener el listado de estados de Estado diario.';
    throw error;
  }
}

export async function getActiveInternalStates() {
  try {
    const response = await api.get(
      `${API_BASE_URL}/CasesSaas/InternalStates/Active`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    error.customMessage =
      'No se pudo obtener el listado de estados internos activos.';
    throw error;
  }
}
